import { Component, ElementRef } from '@angular/core';

@Component({
  selector: 'hub-base-walkthrough-step',
  templateUrl: './base-walkthrough-step.component.html',
  styleUrls: ['./base-walkthrough-step.component.scss'],
})
export class BaseWalkthroughStepComponent {
  constructor(public el: ElementRef) {}
}
